const calculators = document.querySelectorAll('.block-calculator-injury-cost');

const currency = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

const initCalculator = (calculator) => {
	const rows = [];
	const tabs = [
		...calculator.querySelectorAll('.block-calculator-injury-cost__tab'),
	];
	const panel = calculator.querySelector(
		'.block-calculator-injury-cost__inputs'
	);
	const injuryRow = calculator.querySelector(
		'.block-calculator-injury-cost__row--injury'
	);
	const manualRow = calculator.querySelector(
		'.block-calculator-injury-cost__row--manual'
	);
	const marginInput = calculator.querySelector(
		'.block-calculator-injury-cost__input--margin'
	);
	const instancesInput = calculator.querySelector(
		'.block-calculator-injury-cost__input--instances'
	);
	const estimateInput = calculator.querySelector(
		'.block-calculator-injury-cost__input--estimate'
	);
	const injurySelect = calculator.querySelector(
		'.block-calculator-injury-cost__select'
	);
	const addButton = calculator.querySelector(
		'.block-calculator-injury-cost__add-button'
	);
	const summary = calculator.querySelector(
		'.block-calculator-injury-cost__summary'
	);
	const tableBody = calculator.querySelector(
		'.block-calculator-injury-cost__rows'
	);
	const columnLabels = [
		...calculator.querySelectorAll(
			'.block-calculator-injury-cost__table th'
		),
	].map((th) => th.textContent.trim());

	const isInjuryMode = () => injuryRow.hidden === false;

	const updateAddButton = () => {
		addButton.classList.toggle(
			'block-calculator-injury-cost__add-button--inactive',
			isInjuryMode() && !injurySelect.value
		);
	};

	const createRow = () => {
		const instances = instancesInput.value;
		const selectedInjury = injurySelect.selectedOptions[0];
		const directCost = isInjuryMode()
			? Number(selectedInjury.dataset.directCost) * instances
			: estimateInput.value * instances;

		return {
			injuryType: isInjuryMode() ? selectedInjury.value : 'Claims Cost',
			instances,
			directCost,
			indirectCost: directCost * 1.1,
			totalCost: directCost * 1.1 + directCost,
		};
	};

	const createCells = (values) => {
		const tr = document.createElement('tr');

		values.forEach((value, index) => {
			const td = document.createElement('td');
			td.textContent = value;
			td.dataset.label = columnLabels[index];
			tr.append(td);
		});

		return tr;
	};

	const getTotals = () => ({
		instances: rows.reduce(
			(sum, row) => parseInt(sum) + parseInt(row.instances),
			0
		),
		directCost: rows.reduce((sum, row) => sum + row.directCost, 0),
		indirectCost: rows.reduce((sum, row) => sum + row.indirectCost, 0),
		totalCost: rows.reduce((sum, row) => sum + row.totalCost, 0),
	});

	const render = () => {
		summary.hidden = 0 === rows.length;

		const tableRows = rows.map((row) =>
			createCells([
				row.injuryType,
				row.instances,
				currency.format(row.directCost),
				currency.format(row.indirectCost),
				currency.format(row.totalCost),
				currency.format(row.totalCost / marginInput.value),
			])
		);

		if (rows.length > 1) {
			const totals = getTotals();
			const totalsRow = createCells([
				'',
				totals.instances,
				currency.format(totals.directCost),
				currency.format(totals.indirectCost),
				currency.format(totals.totalCost),
				currency.format(totals.totalCost / marginInput.value),
			]);
			totalsRow.classList.add('block-calculator-injury-cost__totals');
			tableRows.push(totalsRow);
		}

		tableBody.replaceChildren(...tableRows);
	};

	addButton.addEventListener('click', () => {
		rows.push(createRow());
		render();
	});

	marginInput.addEventListener('input', render);

	calculator
		.querySelector('.block-calculator-injury-cost__calculator')
		.addEventListener('click', () => {
			if (!window.dataLayer) {
				return;
			}

			window.dataLayer.push({ event: 'toolInteraction' });
		});

	const selectTab = (selectedTab) => {
		tabs.forEach((tab) => {
			const isSelected = tab === selectedTab;
			tab.classList.toggle('is-active', isSelected);
			tab.setAttribute('aria-selected', isSelected);
			tab.tabIndex = isSelected ? 0 : -1;
		});

		const injuryMode = 'injury' === selectedTab.dataset.mode;
		injuryRow.hidden = !injuryMode;
		manualRow.hidden = injuryMode;
		panel.setAttribute('aria-labelledby', selectedTab.id);
		updateAddButton();
	};

	injurySelect.addEventListener('change', updateAddButton);

	tabs.forEach((tab, index) => {
		tab.addEventListener('click', () => selectTab(tab));

		tab.addEventListener('keydown', (e) => {
			let nextIndex;

			if ('ArrowRight' === e.key) {
				nextIndex = (index + 1) % tabs.length;
			} else if ('ArrowLeft' === e.key) {
				nextIndex = (index - 1 + tabs.length) % tabs.length;
			} else if ('Home' === e.key) {
				nextIndex = 0;
			} else if ('End' === e.key) {
				nextIndex = tabs.length - 1;
			} else {
				return;
			}

			e.preventDefault();
			selectTab(tabs[nextIndex]);
			tabs[nextIndex].focus();
		});
	});
};

calculators.forEach(initCalculator);
